import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { AuthGuard } from "./_guards/auth.guard";
import { LoginWithGeoOneSsoComponent } from './login-with-geo-one-sso/login-with-geo-one-sso.component';
@NgModule({
    imports: [
        RouterModule.forRoot([{
            path: 'loginwithgeoonesso',
            component: LoginWithGeoOneSsoComponent,
            // children:[
            //     {
            //         path:'',
            //         component:
            //     }
            // ]
        },
        {
            path: '', component: AppLayoutComponent,
            children: [
                { path: '', redirectTo: "/pages/maptiler", pathMatch: "full" },
                { path: 'pages1', loadChildren: () => import('./demo/components/pages/pages.module').then(m => m.PagesModule) },
                { path: 'pages', canActivateChild: [AuthGuard], loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
            ]
        },
        { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
        { path: 'notfound', component: NotfoundComponent },
        { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
